import { FunctionComponent } from 'react';

import SectionHeroCompany from 'components/modules/public/layout/sections/HeroCompany';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageAboutSectionHero: FunctionComponent<Props> = ({
    translations: {
        background,
        underline,
        headline,
        subheadline,
        headlineMobile,
    },
}) => {
    return (
        <StyledComponent
            className="public-page-about-section-hero"
        >
            <SectionHeroCompany
                background={background}
                underline={underline}
                headline={headline}
                subheadline={subheadline}
            />
            <div className="public-page-about-section-hero-mobile">
                <div className="copy-mobile">
                    {headline && (
                        <div className="headline-wrapper-mobile">
                            <div
                                className="headline-mobile-background"
                                style={{ backgroundImage: `url(${underline})` }}
                            >
                                <div
                                    className="headline-mobile"
                                    dangerouslySetInnerHTML={{ __html: headlineMobile.line1 }}
                                />
                            </div>
                            <div
                                className="headline-mobile-background"
                                style={{ backgroundImage: `url(${underline})` }}
                            >
                                <div
                                    className="headline-mobile"
                                    dangerouslySetInnerHTML={{ __html: headlineMobile.line2 }}
                                />
                            </div>
                            <div
                                className="headline-mobile-background"
                                style={{ backgroundImage: `url(${underline})` }}
                            >
                                <div
                                    className="headline-mobile"
                                    dangerouslySetInnerHTML={{ __html: headlineMobile.line3 }}
                                />
                            </div>
                            <div
                                className="headline-mobile-background"
                                style={{ backgroundImage: `url(${underline})` }}
                            >
                                <div
                                    className="headline-mobile"
                                    dangerouslySetInnerHTML={{ __html: headlineMobile.line4 }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </StyledComponent>
    );
};

export default PublicPageAboutSectionHero;